export class SettingValues{


    public static createSandBoxUserOnMapClick = ["disabled","enabled"];
    public static maxTripSize = 29;
    public static maxRequestSize = 23;

    constructor(){
        
    }
}